import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import t from "@zendesk/client-i18n-tools";
import { hasEntitlement } from "@zendesk/knowledge-context";
import { STAFF, SIGNED_IN_USERS, USER_TYPE_NAME } from "../../../../constants";
import * as actions from "../../../../actions/userSegment";
import styles from "./index.css";

export class ReviewStep extends Component {
  render() {
    const {
      name,
      userType,
      tags,
      groups,
      organizations,
      userCount,
      isAdmin,
    } = this.props;

    return (
      <div className={styles.stepBody} data-test-id="step-body">
        <h2 className={styles.stepTitle}>
          {t("knowledge-user-segments.wizard.reviewTitle")}
        </h2>
        <table>
          <tbody>
            <tr>
              <th className={styles.propertyTitle}>
                {t("knowledge-user-segments.wizard.nameLabel")}
              </th>
              <td>{name}</td>
            </tr>
            <tr>
              <th className={styles.propertyTitle}>
                {t("knowledge-user-segments.wizard.userTypeLabel")}
              </th>
              <td>{t(USER_TYPE_NAME[userType])}</td>
            </tr>
            <tr>
              <th className={styles.propertyTitle}>
                {t("knowledge-user-segments.userSegment.tags")}
              </th>
              <td>{tags.length > 0 ? tags.join(", ") : "-"}</td>
            </tr>

            {userType === STAFF && (
              <tr>
                <th className={styles.propertyTitle}>
                  {t("knowledge-user-segments.userSegment.groups")}
                </th>
                <td>
                  {groups.length > 0
                    ? groups.map(({ name }) => name).join(", ")
                    : "-"}
                </td>
              </tr>
            )}

            {userType === SIGNED_IN_USERS && (
              <tr>
                <th className={styles.propertyTitle}>
                  {t("knowledge-user-segments.userSegment.organizations")}
                </th>
                <td>
                  {organizations.length > 0
                    ? organizations.map(({ name }) => name).join(", ")
                    : "-"}
                </td>
              </tr>
            )}

            {isAdmin && (
              <tr>
                <th className={styles.propertyTitle}>
                  {t("knowledge-user-segments.userSegment.matchingUsers")}
                </th>
                <td>{userCount}</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    );
  }
}

ReviewStep.propTypes = {
  isAdmin: PropTypes.bool,
  name: PropTypes.string,
  userType: PropTypes.oneOf([STAFF, SIGNED_IN_USERS]),
  tags: PropTypes.arrayOf(PropTypes.string).isRequired,
  groups: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
    })
  ).isRequired,
  organizations: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
    })
  ).isRequired,
  userCount: PropTypes.number,
};

ReviewStep.defaultProps = {
  tags: [],
  groups: [],
  organizations: [],
};

const mapStateToProps = ({ userSegment }, { type }) => ({
  name: userSegment.name,
  userType: userSegment.userType,
  tags: userSegment.tags,
  organizations: userSegment.organizations,
  groups: userSegment.groups,
  userCount: userSegment.userCount,
  isAdmin: hasEntitlement("admin"),
});

const mapDispatchToProps = (dispatch, { type }) =>
  bindActionCreators({ ...actions }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ReviewStep);



// WEBPACK FOOTER //
// ./src/components/NewUserSegment/components/ReviewStep/index.js